import React from 'react';
import { RequirementsProps } from '../../tools/context';
import { LinkProps } from '../index';
import { Picto } from '../Picto';

export interface NavigationProps {
  requirements: RequirementsProps;
  closeCallback: () => void | undefined;
  navigation: LinkProps[];
}

const Navigation = (props: NavigationProps) => {
  return (
    <nav className="navigation" id="main-navigation" aria-label="Menu principal">
      <button className="close" onClick={props.closeCallback} aria-label="Fermer le menu">
        <Picto iconKey={'cross'} aria-hidden="true" />
      </button>
      <ul className="list">
        {props.navigation.map((n, i) => (
          <li key={`navigation_${i}`}>
            <a
              className={`line ${props.requirements.path === n.link ? 'current' : ''}`}
              href={n.link}
              aria-current={props.requirements.path === n.link ? 'page' : undefined}
            >
              {n.picto && <Picto iconKey={n.picto} aria-hidden="true" />}
              {n.text}
              {props.requirements.path === n.link && <div className={'separator'} aria-hidden="true" />}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
